/**
 * EventListingsPage duck: Sharetribe listings by attraction for merge with Supabase events.
 */

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';

export const FETCH_ATTRACTION_SHARETRIBE_REQUEST =
  'app/EventListingsPage/FETCH_ATTRACTION_SHARETRIBE_REQUEST';
export const FETCH_ATTRACTION_SHARETRIBE_SUCCESS =
  'app/EventListingsPage/FETCH_ATTRACTION_SHARETRIBE_SUCCESS';
export const FETCH_ATTRACTION_SHARETRIBE_ERROR =
  'app/EventListingsPage/FETCH_ATTRACTION_SHARETRIBE_ERROR';

const initialState = {
  attractionSharetribeFetchInProgress: false,
  attractionSharetribeError: null,
  attractionSharetribeListingIds: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ATTRACTION_SHARETRIBE_REQUEST:
      return {
        ...state,
        attractionSharetribeFetchInProgress: true,
        attractionSharetribeError: null,
      };
    case FETCH_ATTRACTION_SHARETRIBE_SUCCESS:
      return {
        ...state,
        attractionSharetribeFetchInProgress: false,
        attractionSharetribeListingIds: payload || [],
      };
    case FETCH_ATTRACTION_SHARETRIBE_ERROR:
      return {
        ...state,
        attractionSharetribeFetchInProgress: false,
        attractionSharetribeError: payload,
        attractionSharetribeListingIds: [],
      };
    default:
      return state;
  }
}

export const fetchAttractionSharetribeRequest = () => ({
  type: FETCH_ATTRACTION_SHARETRIBE_REQUEST,
});

export const fetchAttractionSharetribeSuccess = listingIds => ({
  type: FETCH_ATTRACTION_SHARETRIBE_SUCCESS,
  payload: listingIds,
});

export const fetchAttractionSharetribeError = e => ({
  type: FETCH_ATTRACTION_SHARETRIBE_ERROR,
  payload: e,
  error: true,
});

/**
 * Fetch Sharetribe listings by attraction name (keywords).
 * Stores listing ids in state so EventListingsPage can merge with Supabase events.
 */
export const fetchSharetribeListingsByAttraction = attractionName => (dispatch, getState, sdk) => {
  if (!attractionName || typeof attractionName !== 'string' || !attractionName.trim()) {
    dispatch(fetchAttractionSharetribeSuccess([]));
    return Promise.resolve([]);
  }
  dispatch(fetchAttractionSharetribeRequest());
  const baseQueryParams = {
    keywords: attractionName.trim(),
    include: ['author', 'images'],
    'fields.listing': ['title', 'description', 'price', 'publicData', 'metadata'],
    per_page: 50,
    states: ['published'],
    pub_listingType: 'buying-tickets',
  };
  return sdk.listings
    .query(baseQueryParams)
    .then(response => {
      const listings = response?.data?.data || [];
      if (response) {
        dispatch(addMarketplaceEntities(response));
      }
      const listingIds = listings.map(l => l.id?.uuid ?? l.id);
      dispatch(fetchAttractionSharetribeSuccess(listingIds));
      return listingIds;
    })
    .catch(error => {
      console.error('EventListingsPage: Error fetching Sharetribe listings by attraction:', error);
      dispatch(fetchAttractionSharetribeError(storableError(error)));
      return [];
    });
};
